<template>
    <v-container
        :style="{ 'grid-template-columns': gridTwoLayer ? 'repeat(auto-fit, minmax(85px, 1fr))' : 'repeat(auto-fit, minmax(145px, 1fr))'}"
        class="pa-0 ma-0 shortcuts-wrapper"
    >
        <v-container
            v-for="n in 30"
            :key="n"
            :class="{ 'flex-column': gridTwoLayer }"
            class="pa-1 ma-0 product-thumbnail"
        >
            <div
                :style="{
                    'width': !gridTwoLayer && imgVisibility ? '80%' : ''
                }"
                class="d-flex justify-center"
            >
                <img
                    src="@/assets/image.png"
                    class="w-100"
                    :class="{ 'd-none': !imgVisibility }"
                    alt="product-img"
                />
            </div>
            <v-card-text class="text-caption pa-0 text-product">کرم مرطوب کننده ی لاکچری کرم مرطوب کننده ی لاکچری کرم مرطوب کننده ی لاکچری کرم مرطوب کننده ی لاکچری</v-card-text>
        </v-container>
    </v-container>
</template>

<script>
export default {
  props: {
    gridTwoLayer: Boolean,
    imgVisibility: Boolean
  },
  watch: {
    imgVisibility (val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.shortcuts-wrapper {
    overflow: auto;
    height: 100%;
    scrollbar-width: none;
    display: grid;
    gap: 0.5rem;
}
.shortcuts-wrapper .product-thumbnail {
    border: 1px solid silver;
    border-radius: 4px;
    display: flex;
    gap: .25rem;
    cursor: pointer;
}
.shortcuts-wrapper .product-thumbnail img {
    border: 1px solid #c0c0c04f;
    padding: 1px;
    border-radius: 3px;
}
.text-product {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
